import { ELinkVariant, ETextStyleVariant, Link, Text } from '@outdoorsyco/bonfire';
import React from 'react';
import { useIntl } from 'react-intl';

import { IAddress } from '@/components/route/campground/campgroundTypes';
import { formatAddress } from '@/utility/address';
import { ICoordinates } from '@/utility/commonDataTypes';

type TLocationProps = {
  location: ICoordinates;
  address?: IAddress;
};

export const Location = ({ location, address }: TLocationProps) => {
  const intl = useIntl();

  return (
    <div className="flex flex-col gap-6">
      <Text variant={ETextStyleVariant.LargeBold}>
        {intl.formatMessage({ defaultMessage: 'Location', id: 'rvirM2' })}
      </Text>

      <div className="flex flex-col gap-4">
        {address && (
          <Link
            variant={ELinkVariant.Underline}
            href={`https://www.google.com/maps/search/${location.lat},${location.lon}`}
            target="_blank">
            <Text variant={ETextStyleVariant.MediumRegular}>
              {formatAddress({
                address: {
                  street1: address.street,
                  city: address.city,
                  state: address.state,
                  zip: address.postal_code,
                  countryCode: address.country,
                },
                showCountry: false,
              })}
            </Text>
          </Link>
        )}

        <Text variant={ETextStyleVariant.MediumRegular}>
          <Coordinates {...location} />
        </Text>
      </div>
    </div>
  );
};

type TCoordinatesProps = {
  lat: number;
  lon: number;
};

const Coordinates = ({ lat, lon }: TCoordinatesProps) => {
  const intl = useIntl();

  return (
    <>
      {`${Math.abs(lat)}° ${
        lat < 0
          ? intl.formatMessage({ defaultMessage: 'S', id: '2jnRwh', description: 'south' })
          : intl.formatMessage({ defaultMessage: 'N', id: 'PpM5bj', description: 'north' })
      }`}
      ,{' '}
      {`${Math.abs(lon)}° ${
        lon < 0
          ? intl.formatMessage({ defaultMessage: 'W', id: 'J1wGUy', description: 'west' })
          : intl.formatMessage({ defaultMessage: 'E', id: 'wQzM1A', description: 'east' })
      }`}
    </>
  );
};
